import Vue from 'vue';
import ApiRequest from '@/tools/ApiRequest';
import formValidationRules from '@/tools/validationRules/formValidationRules';
import Product from '@/tools/models/Product';
import textFieldDefaultProps from '@/tools/helpers/textFieldDefaultProps';
import sortByTile from '@/tools/helpers/sortByTitle';
import RequestException from '@/tools/helpers/RequestException';

export default Vue.extend({
  name: 'productList',
  props: {
    maxHeight: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    textFieldProps: textFieldDefaultProps,
    products: [] as Product[],
    validationRules: formValidationRules,
  }),
  methods: {
    getProductsFromApi(): void {
      ApiRequest.getProducts()
        .then((response) => {
          response.data.forEach((el: any) => {
            el.quant = '';
            this.products.push(el);
          });

          sortByTile(this.products);

          this.$emit('products-filled');
        })
        .catch((error) => new RequestException(error, this.$store, this.$router));
    },
    getSelectedProducts(): Product[] {
      const selectedProducts: Product[] = [];

      this.products.forEach((el) => {
        if (el.quant !== '') {
          selectedProducts.push(el);
        }
      });

      return selectedProducts;
    },
  },
  created(): void {
    this.getProductsFromApi();
  },
});
